module.exports = __webpack_public_path__ + "fonts/DIN_Alternate_Bold.61268bf5.ttf";